import { useTranslation } from 'react-i18next';

export const FlowSection = () => {
  const { t } = useTranslation();

  return (
    <section id="como-funciona" className="py-12 lg:py-24 bg-blue-50/50 border-t border-gray-100 relative overflow-hidden">
      {/* Subtle architectural lines */}
      <div className="absolute inset-0 z-0 opacity-[0.05]" style={{
        backgroundImage: 'linear-gradient(45deg, #0575E6 1px, transparent 1px), linear-gradient(-45deg, #0575E6 1px, transparent 1px)',
        backgroundSize: '60px 60px'
      }}></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">

        <div className="text-center mb-16 animate-on-scroll">
          <h2 className="font-audiowide text-3xl sm:text-4xl text-[#111111] mb-6">{t('flow.title')}</h2>
          <div className="w-24 h-1 bg-gradient-to-r from-brand-electric-blue to-brand-neon-green mx-auto rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative">
          {/* Decorative Connection Line for Desktop */}
          <div className="hidden md:block absolute top-[50px] left-[15%] right-[15%] h-px bg-gray-200 z-0"></div>

          {[
            {
              step: '01',
              title: t('flow.step1.title'),
              desc: t('flow.step1.desc'),
              icon: 'fa-file-pdf'
            },
            {
              step: '02',
              title: t('flow.step2.title'),
              desc: t('flow.step2.desc'),
              icon: 'fa-link'
            },
            {
              step: '03',
              title: t('flow.step3.title'),
              desc: t('flow.step3.desc'),
              icon: 'fa-qrcode'
            }
          ].map((item, i) => (
            <div key={i} className="relative z-10 text-center animate-on-scroll">
              <div className="w-24 h-24 bg-white border-2 border-gray-100 rounded-full flex items-center justify-center mx-auto mb-6 shadow-sm">
                <span className="font-audiowide text-brand-electric-blue text-xl absolute -ml-16 -mt-16 opacity-30 text-5xl">{item.step}</span>
                <i className={`fas ${item.icon} text-3xl text-[#111111]`}></i>
              </div>
              <h3 className="font-audiowide text-xl text-[#111111] mb-3">{item.title}</h3>
              <p className="font-montserrat text-[#333333] leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Subtle Bottom Divider */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-[0] transform rotate-180">
        <svg className="relative block w-[calc(100%+1.3px)] h-[40px] fill-white" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"></path>
        </svg>
      </div>
    </section>
  );
};
